import { useCallback, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

export default function Verified() {
    const history = useHistory();
    const location = useLocation();
    const queryParams = new URLSearchParams(history.location.search);
    const niceResultCode = queryParams.get("niceResultCode");
    const verifyType = queryParams.get("verifyType");
    const tokenVersionId = queryParams.get("tokenVersionId");

    const handleLoad = useCallback(() => {
        if (!!niceResultCode && !!verifyType && !!tokenVersionId) {
            const openerLocation = window.opener?.document.location;
            if (openerLocation) {
                openerLocation.href = `${openerLocation.href}?verifyType=${verifyType}&tokenVersionId=${tokenVersionId}&niceResultCode=${niceResultCode}`;
            }
            window.close();
        }
    }, [history, niceResultCode, verifyType, tokenVersionId]);

    useEffect(() => {
        if (!window.opener) {
            history.goBack();
        } else {
            handleLoad();
        }
    }, [handleLoad, history, location.search]);

    return null;
}
